import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import * as categoryTemplateActions from "../../../actions/categoryTemplateActions";
import CategoryEditorHook from "./CategoryEditorHook";
import GroupContainerHook from "../groups/GroupContainerHook";

const CategoryContainerHook = ({ templateKey: propTemplateKey, match = {} }) => {
    const [templateKey, setTemplateKey] = useState("");
    const template = useSelector(state => state.categoryTemplate);
    const dispatch = useDispatch();

    useEffect(() => {
        let resolvedTemplateKey;
        if (!propTemplateKey) {
            resolvedTemplateKey = match.params?.templateKey || "";
        } else {
            resolvedTemplateKey = propTemplateKey;
        }
        setTemplateKey(resolvedTemplateKey);
        dispatch(categoryTemplateActions.getCategoryTemplate(resolvedTemplateKey));
    }, [propTemplateKey, match.params?.templateKey, dispatch]);

    const getQuestionPreview = () => {
        let html;

        if (template !== undefined) {
            html = (
                <div id="CategoryContainer-container-div">
                    <Card>
                        <CardHeader
                            title={"Category: " + (template[templateKey] ? template[templateKey].name : "")}
                            titleTypographyProps={{color: "purple"}}
                            subtitle={"Key: "+templateKey}
                            actAsExpander
                        >
                            {/*<CategoryReview template={template[templateKey]} />*/}
                        </CardHeader>
                        <CardContent expandable>
                            <CategoryEditorHook templateKey={templateKey} template={template[templateKey]} width="90%" scrollTo="CategoryContainer-container-div"/>
                        </CardContent>
                        <CardContent>
                            {
                                template[templateKey] !== undefined ?
                                    template[templateKey].groupKeys.map(function (groupKey) {
                                        return <GroupContainerHook key={groupKey} templateKey={groupKey} />;
                                    })
                                    : ""
                            }
                        </CardContent>
                    </Card>
                </div>
            );
        } else {
            html = <div />;
        }
        return html;
    };

    return getQuestionPreview();
};

CategoryContainerHook.defaultProps = {
    match: {},
    templateKey: ""
};

CategoryContainerHook.propTypes = {
    templateKey: PropTypes.string,
    match: PropTypes.object
};

export default CategoryContainerHook;